import { render } from "./hr-chips.vue?vue&type=template&id=5596d302&scoped=true"
import script from "./hr-chips.vue?vue&type=script&lang=js"
export * from "./hr-chips.vue?vue&type=script&lang=js"

import "./hr-chips.vue?vue&type=style&index=0&id=5596d302&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5596d302"]])

export default __exports__